export function paramFromWindowLocation(paramKey: string) {
    const hashParams = new URLSearchParams(window.location.hash.split('?')[1]);
    return hashParams.get(paramKey);
}